import { useState, useEffect } from "react";
import { CrudPage } from "../components/CrudPage";
import { api } from "../lib/api";
import { useLang } from "../lib/i18n";
import { fmtIDR } from "../lib/format";

export default function Products() {
  const { t } = useLang();
  const [meta, setMeta] = useState({ categories: [] });

  useEffect(() => { api.get("/meta/all").then((r) => setMeta(r.data)).catch(() => {}); }, []);
  const catOptions = meta.categories.filter((c) => c.type !== "ingredient").map((c) => ({ value: c.id, label: c.name }));
  const catName = (id) => meta.categories.find((c) => c.id === id)?.name || "-";

  return (
    <CrudPage
      title={t("nav_products")}
      endpoint="products"
      testPrefix="products"
      defaults={{ active: true }}
      columns={[
        { key: "image", label: "", render: (p) => p.image ? <img src={p.image} alt="" className="w-10 h-10 rounded-lg object-cover" /> : <div className="w-10 h-10 rounded-lg bg-muted" /> },
        { key: "name", label: t("name") },
        { key: "sku", label: "SKU" },
        { key: "category_id", label: t("category"), render: (p) => catName(p.category_id) },
        { key: "price", label: t("price"), render: (p) => <span className="font-mono">{fmtIDR(p.price)}</span> },
        { key: "hpp", label: "HPP", render: (p) => <span className="font-mono text-muted-foreground">{fmtIDR(p.hpp)}</span> },
        { key: "suggested_price", label: t("suggestedPrice"), render: (p) => <span className="font-mono text-amber-600">{fmtIDR(p.suggested_price)}</span> },
        { key: "active", label: t("active"), render: (p) => p.active ? <span className="bg-emerald-50 dark:bg-emerald-950/50 text-emerald-700 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-800 px-2.5 py-0.5 rounded-full text-xs font-semibold">✓</span> : "–" },
      ]}
      fields={[
        { name: "name", label: t("name") },
        { name: "sku", label: "SKU" },
        { name: "category_id", label: t("category"), type: "select", options: catOptions },
        { name: "price", label: t("price"), type: "number" },
        { name: "image", label: "Foto URL", type: "image" },
        { name: "description", label: "Deskripsi", type: "textarea" },
        { name: "active", label: t("active"), type: "checkbox" },
      ]}
    />
  );
}
